import React, { useEffect, useState } from "react"
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import BottomNavigation from "components/BottomNavigation"
import { FormSection } from "redux-form"
import BackgroundTab from "./backgroundTab"
import IconTab from "./iconTab"
import PhonePreview from "./phonePreview"
import TileTab from "./tileTab"

const DesignTab = ({
  handleNext,
  handleSave,
  tabIsActive,
  setSubTabBreadcrumb,
}) => {
  const TABS = {
    BACKGROUND: 1,
    TILE: 2,
    ICON: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.BACKGROUND)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (tabIsActive) {
      setActiveTab(TABS.BACKGROUND)
      setSubTabBreadcrumb("Background", () => {
        setActiveTab(TABS.BACKGROUND)
      })
    }
  }, [tabIsActive])

  useEffect(() => {
    let tabTitle = ""
    switch (activeTab) {
      case 1:
        tabTitle = "Background"
        break
      case 2:
        tabTitle = "Tile"
        break
      case 3:
        tabTitle = "Icon"
        break
      default:
        break
    }
    setSubTabBreadcrumb(tabTitle, () => {
      setActiveTab(TABS.BACKGROUND)
    })
  }, [activeTab])

  return (
    <Row>
      <Col xl={8}>
        <Row className="my-3">
          <Col xs="auto ms-5">
            <Nav pills className="flex-column">
              <NavItem>
                <NavLink
                  className={markIfIsActive(TABS.BACKGROUND)}
                  onClick={() => setActiveTab(TABS.BACKGROUND)}
                  style={
                    activeTab === TABS.BACKGROUND
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Background</span>}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={markIfIsActive(TABS.TILE)}
                  onClick={() => setActiveTab(TABS.TILE)}
                  style={
                    activeTab === TABS.TILE
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Tile</span>}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={markIfIsActive(TABS.ICON)}
                  onClick={() => setActiveTab(TABS.ICON)}
                  style={
                    activeTab === TABS.ICON
                      ? {}
                      : { backgroundColor: "#eff2f7" }
                  }
                >
                  {<span style={{ fontSize: "16px" }}>Icon</span>}
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col>
            <TabContent
              activeTab={activeTab}
              className="text-muted mt-4 mt-md-0"
            >
              <TabPane style={{ animation: "none" }} tabId={TABS.BACKGROUND}>
                <FormSection name="background">
                  <BackgroundTab
                    tabIsActive={tabIsActive && activeTab === TABS.BACKGROUND}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleNext={() => setActiveTab(TABS.TILE)}
                    handleSave={handleSave}
                  />
                </FormSection>
              </TabPane>
              <TabPane style={{ animation: "none" }} tabId={TABS.TILE}>
                <FormSection name="tile">
                  <TileTab
                    tabIsActive={tabIsActive && activeTab === TABS.TILE}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.BACKGROUND)}
                    handleNext={() => setActiveTab(TABS.ICON)}
                    handleSave={handleSave}
                  />
                </FormSection>
              </TabPane>
              <TabPane style={{ animation: "none" }} tabId={TABS.ICON}>
                <FormSection name="icon">
                  <IconTab
                    tabIsActive={tabIsActive && activeTab === TABS.ICON}
                    handleSave={handleSave}
                  />
                  <BottomNavigation
                    handleBack={() => setActiveTab(TABS.TILE)}
                    handleNext={handleNext}
                    handleSave={handleSave}
                  />
                </FormSection>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Col>
      <Col xl={4} className="mt-4 d-none d-xl-block">
        <PhonePreview />
      </Col>
    </Row>
  )
}

export default DesignTab
